import axios from 'axios';
import { API_BASE_URL as BASE_URL } from './config';

// ── Bump this on every release ───────────────────────────────────────────────
export const WEB_VERSION = '1.0.0';

export interface AppVersionConfig {
  platform: string;
  currentVersion: string;
  minSupportedVersion: string;
  forceUpdate: boolean;
  updateMessage: string;
  downloadUrl: string;
}

/** Returns true if semver a < b */
function semverLessThan(a: string, b: string): boolean {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    if ((pa[i] ?? 0) < (pb[i] ?? 0)) return true;
    if ((pa[i] ?? 0) > (pb[i] ?? 0)) return false;
  }
  return false;
}

export interface VersionCheckResult {
  forceUpdate: boolean;
  message: string;
  downloadUrl: string;
  latestVersion: string;
}

export const appVersionService = {
  /**
   * Called on startup.
   * - If WEB_VERSION < currentVersion AND forceUpdate=true  → blocking update wall
   * - If WEB_VERSION < currentVersion AND forceUpdate=false → dismissible banner
   * - If WEB_VERSION >= currentVersion                      → null (no popup)
   * Network errors are swallowed so they never block the app.
   */
  async check(): Promise<VersionCheckResult | null> {
    try {
      const { data: cfg } = await axios.get<AppVersionConfig>(
        `${BASE_URL}/public/app-version`,
        { params: { platform: 'web' } },
      );
      if (semverLessThan(WEB_VERSION, cfg.currentVersion)) {
        return {
          forceUpdate: cfg.forceUpdate ?? false,
          message: cfg.updateMessage || (
            cfg.forceUpdate
              ? 'A required update is available. Please refresh to continue.'
              : 'A new version is available. Refresh to get the latest features.'
          ),
          downloadUrl: cfg.downloadUrl || '',
          latestVersion: cfg.currentVersion,
        };
      }
      return null;
    } catch {
      return null;
    }
  },
};
